/**
 * Trunnion AI - Onboarding Tour Step Definitions
 * Defines each step of the interactive onboarding tour including target selectors,
 * tooltip content, and placement configuration.
 */

export type TourPlacement = 'top' | 'bottom' | 'left' | 'right';

export interface TourStep {
  /** Unique identifier for this step */
  id: string;
  /** CSS selector used to locate the target element on the page */
  target: string;
  /** Heading displayed in the tooltip */
  title: string;
  /** Explanatory text displayed beneath the title */
  description: string;
  /** Tooltip position relative to the target element */
  placement: TourPlacement;
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: 'sidebar-nav',
    target: 'aside[aria-label="Main navigation"]',
    title: 'Navigation',
    description: 'Use the sidebar to navigate between sections.',
    placement: 'right',
  },
  {
    id: 'workflows-link',
    target: 'a[href="/workflows"]',
    title: 'Workflows',
    description: 'Design and manage your AI workflows here.',
    placement: 'right',
  },
  {
    id: 'agents-link',
    target: 'a[href="/agents"]',
    title: 'Agents',
    description: 'Configure and deploy your AI agents.',
    placement: 'right',
  },
  {
    id: 'templates-link',
    target: 'a[href="/templates"]',
    title: 'Templates',
    description: 'Browse pre-built workflow templates.',
    placement: 'right',
  },
  {
    id: 'command-palette',
    target: 'button:has(.lucide-search)',
    title: 'Quick Search',
    description: 'Press \u2318K anytime to quickly search and navigate.',
    placement: 'bottom',
  },
  {
    id: 'notification-bell',
    target: 'button[aria-label="Toggle notification center"]',
    title: 'Notifications',
    description: 'Stay informed about approvals and system events.',
    placement: 'bottom',
  },
];
